import trkl from "trkl";
import ConfigService from "./ConfigService";

class JWTServiceClass {
    observable = trkl({});

    constructor() {
        ConfigService.jwt.subscribe(this.updateJWTContent, true);
    }

    updateJWTContent = () => {
        const jwtParts = ConfigService.jwt().split('.');
        const jwtContent = jwtParts.length === 3 ? JSON.parse(atob(jwtParts[1])) : {};
        this.observable(jwtContent);
    }
}

const JWTService = new JWTServiceClass();
export default JWTService;



// WEBPACK FOOTER //
// ./services/JWTService.js